/* eslint-disable react-dom/no-missing-iframe-sandbox */
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import {
  useRefreshKycStatus,
} from "@/api/mutations";
import { useGetMyAccount } from "@/api/queries";
import { apiCall } from "@/api/shared";
import FormError from "@/components/FormError";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function IdenfyIFrame(authData) {
  const navigate = useNavigate();
  const authDataObj = { authData };
  const authUrl = authDataObj?.authData?.authToken?.authurl;
  const refreshKycStatusMutation = useRefreshKycStatus();
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });

  function responseReceived(res) {
    const fetchKycStatus = async () => {
      const kyc = await apiCall({
        endpoint: "/rightsapp/get",
        path: "/api/v1/user/getkyc",
      });

      // AppState.update((s) => {
      //   s.kyc = kyc;
      // });
      useAppStore.setState({ kyc });
    };
    fetchKycStatus();
    // AppState.update((s) => {
    //   s.navItemsEnabled = true;
    // });
    useAppStore.setState({ navItemsEnabled: true });
    if (res?.kycpassed === true) {
      myAccount.refetch();
      setTimeout(() => {
        navigate({ to: "/security-success" });
      }, 2000);
    }
    else if (res?.kycpassed === false) {
      setTimeout(() => {
        navigate({ to: "/security-failed" });
      }, 2000);
    }
  }

  function errorReceived(error) {
    // AppState.update((s) => {
    //   s.navItemsEnabled = true;
    // });
    useAppStore.setState({ navItemsEnabled: true });
    setValidationErrorMessage(error.message);
    console.error("refreshkycFailed", error);
    // AppState.update((s) => {
    //   s.navItemsEnabled = true;
    // });
    useAppStore.setState({ navItemsEnabled: true });
  }

  function receiveMessage(event) {
    if (event?.data?.status != null && event?.data?.status !== undefined && event?.data?.status !== "undefined") {
      refreshKycStatusMutation.reset();

      refreshKycStatusMutation.mutate(null, {
        onSuccess: (res) => {
          if (res?.pendingkyccheck === false) {
            responseReceived(res);
          }
        },
        onError: (error) => {
          errorReceived(error);
        },
      });
    }
  }

  window.addEventListener("message", receiveMessage, false);

  return (
    <>
      <div>
        {authUrl != null && authUrl !== undefined && authUrl !== "undefined"}
        <div>
          <iframe
            title="identity verification"
            id="idenfyIframe"
            allowFullScreen
            className="w-full h-screen"
            src={authUrl}
            allow="camera"
          />

          <p id="display" />
        </div>
      </div>
      <Spacer />
      <FormError validationError={validationErrorMessage} />
    </>
  );
}
export default IdenfyIFrame;
